<template>
    <div v-if="isLoaded">
        <div class="content-body"
             v-bind:class="{ fullscreen_expand: isFullscreen }">
            <div class="row match-height">
                <div class="col-xl-12 col-lg-12">
                    <div class="card"
                         style="">
                        <div class="card-header">
                            <h4 class="card-title">Fatura</h4>
                            <a class="heading-elements-toggle"><i class="fa fa-ellipsis-v font-medium-3"
                                   @click="setSubMenuShowHideFw(getSubMenuShowHideFw())"></i></a>
                            <div class="heading-elements"
                                 v-bind:class="{ visible: getSubMenuShowHideFw(), '': !getSubMenuShowHideFw() }">
                                <ul class="list-inline mb-0">
                                    <li><a @click="onPrintFatura(null, 2)"
                                           v-b-tooltip
                                           title="Imprimir"
                                           v-if="getPermission('fatura.index')"><i class="fa fa-print"></i></a></li>
                                    <li><a @click="onPrintFatura(null, 3)"
                                           v-b-tooltip
                                           title="Imprimir lote compactado"
                                           v-if="getPermission('fatura.index')"><i class="fa fa-print"></i></a></li>
                                    <li><a @click="expandFullscreen()"
                                           v-b-tooltip
                                           title="Expande a tela"
                                           v-if="!isFullscreen"><i class="ft-maximize"></i></a></li>
                                    <li><a @click="expandFullscreen()"
                                           v-b-tooltip
                                           title="Minimiza a tela"
                                           v-if="isFullscreen"><i class="ft-minimize"></i></a></li>
                                    <li><a @click="onFilterShowHide()"
                                           v-b-tooltip.hover.left="'Filtros'"><i class="fa fa-filter"></i></a></li>
                                </ul>
                            </div>
                        </div>
                        <div class="card-content">
                            <div class="table-responsive">
                                <div v-if="vuetableFilterRow">
                                    <vuetable-filterbar>
                                    </vuetable-filterbar>
                                </div>
                                <div class="loadingDataPosition">
                                    <div class="loadingData"
                                         v-if="loadingData">
                                        <div class="loadingDataSpinner">
                                            <spinner v-if="loadingData"
                                                     text-fg-color="#ffffff"
                                                     message="Carregando..."></spinner>
                                        </div>
                                    </div>
                                    <vuetable ref="vuetable"
                                              api-url="/api/fatura"
                                              :fields="fieldDynamic"
                                              :css="css"
                                              :append-params="moreParams"
                                              track-by="fatura_id"
                                              pagination-path=""
                                              @vuetable:pagination-data="onPaginationData"
                                              @vuetable:loaded="onLoaded"
                                              detail-row-component="fatura-detalhes">
                                      <template slot="actions" slot-scope="props">
                                        <div class="custom-actions">
                                            <a @click="onEvento(props.rowData, 1,props.rowData.status.valor)" v-b-tooltip title="Cancelar Fatura"><i class="fa fa-thumbs-o-down "></i></a>
                                            <a @click="onDetail(props.rowData, null, null)" v-b-tooltip title="Ver detalhes"><i class="fa fa-plus"></i></a>
                                            <a @click="onPrintFatura(props.rowData, 1)" v-b-tooltip title="Imprimir Fatura"><i class="fa fa-print "></i></a>
                                          </button>
                                        </div>
                                      </template>
                                      <template slot="status" slot-scope="props">
                                          <span class="badge badge-warning" v-if="props.rowData.status.valor==1">{{ props.rowData.status.descr }}</span>
                                          <span class="badge badge-info" v-if="props.rowData.status.valor==2">{{ props.rowData.status.descr }}</span>
                                          <span class="badge badge-success" v-if="props.rowData.status.valor==3">{{ props.rowData.status.descr }}</span>
                                          <span class="badge badge-success" v-if="props.rowData.status.valor==4">{{ props.rowData.status.descr }}</span>
                                          <span class="badge badge-danger" v-if="props.rowData.status.valor==5">{{ props.rowData.status.descr }}</span>
                                          <span class="badge badge-danger" v-if="props.rowData.status.valor==6">{{ props.rowData.status.descr }}</span>
                                          <span class="badge badge-danger" v-if="props.rowData.status.valor==7">{{ props.rowData.status.descr }}</span>
                                        </template>

                                        <template slot="tomador" slot-scope="props">
                                            <span v-if="props.rowData.pessoa.pessoa_juridica!==null">{{ props.rowData.pessoa.pessoa_juridica.razao_social }}</span>
                                            <span v-if="props.rowData.pessoa.pessoa_exterior!==null">{{ props.rowData.pessoa.pessoa_exterior.nome }}</span>
                                            <span v-if="props.rowData.pessoa.pessoa_fisica!==null">{{ props.rowData.pessoa.pessoa_fisica.nome }}</span>
                                        </template>

                                  </vuetable>
                                    <div class='col-md-12'>
                                        <div class="pull-left pagination-detail">
                                            <vuetable-pagination-info ref="paginationInfo"
                                                                      :css="css.pagination"
                                                                      info-class="pull-left"></vuetable-pagination-info>
                                        </div>
                                        <div class="pull-right m-a-0">
                                            <vuetable-pagination ref="pagination"
                                                                 :css="css.pagination"
                                                                 @vuetable-pagination:change-page="onChangePage"></vuetable-pagination>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vuetable from '../components/Vuetable'
    import VuetablePagination from '../components/VuetablePagination'
    import VuetablePaginationInfo from '../components/VuetablePaginationInfo'
    import FaturaFilterBar from './FaturaFilterBar'
    import FaturaDetalhes from './FaturaDetalhes'
    import accounting from 'accounting'
    import moment from 'moment'

    Vue.component('fatura-detalhes', FaturaDetalhes);

    export default {
        components: {
            Vuetable,
            VuetablePagination,
            VuetablePaginationInfo,
            'vuetable-filterbar': FaturaFilterBar,
        },
        data() {
            return {
                modal_titulo: '',
                modal_botao: '',
                modal_acao: '',
                fatura_id: '',
                loading: false,
                isDisabled: false,
                loadingData: true,
                showModal: false,
                isFullscreen: false,
                helpForm: new Form({
                    statusRecord: [],
                    params: []
                }),
                form: new Form({
                    fatura_id: [],
                    tp_print: '',
                    status: '',
                    tp_evento: ''
                }),
                fields: [{
                        name: '__checkbox',
                        titleClass: 'center aligned',
                        dataClass: 'center aligned'
                    },
                    {
                        name: 'num_fiscal',
                        title: 'N° Fatura',
                        sortField: 'num_fiscal'
                    },
                    {
                        name: 'serie',
                        title: 'Série',
                        sortField: 'serie'
                    },
                    {
                        name: 'num_controle',
                        title: 'N° Controle',
                        sortField: 'num_controle'
                    },
                    {
                        name: 'vlr_fatura',
                        title: 'Valor Fatura',
                        callback: 'formatNumber'
                    },
                    {
                        name: '__slot:tomador',
                        title: 'Tomador'
                    },
                    {
                        name: 'dt_emi',
                        title: 'Data Emissão',
                        callback: 'formatDate|DD/MM/YYYY'
                    },
                    {
                        name: 'dt_vencto',
                        title: 'Data Vencimento',
                        callback: 'formatDate|DD/MM/YYYY'
                    },
                    {
                        name: '__slot:status',
                        title: 'Status'
                    },
                    {
                        name: '__slot:actions',
                        title: 'Ações',
                        titleClass: 'center aligned',
                        dataClass: 'center aligned'
                    }
                ],
                fieldsLogin: [{
                        name: '__checkbox',
                        titleClass: 'center aligned',
                        dataClass: 'center aligned'
                    },
                    {
                        name: 'num_controle',
                        title: 'N° Fatura',
                        sortField: 'num_controle'
                    },
                    {
                        name: 'vlr_fatura',
                        title: 'Valor Fatura',
                        callback: 'formatNumber'
                    },
                    {
                        name: '__slot:tomador',
                        title: 'Tomador'
                    },
                    {
                        name: 'dt_emi',
                        title: 'Data Emissão',
                        callback: 'formatDate|DD/MM/YYYY'
                    },
                    {
                        name: 'dt_vencto',
                        title: 'Data Vencimento',
                        callback: 'formatDate|DD/MM/YYYY'
                    },
                    {
                        name: '__slot:status',
                        title: 'Status'
                    },
                    {
                        name: '__slot:actions',
                        title: 'Ações',
                        titleClass: 'center aligned',
                        dataClass: 'center aligned'
                    }
                ],
                css: {
                    tableClass: 'table table-striped',
                    loadingClass: 'loading',
                    ascendingIcon: 'glyphicon glyphicon-chevron-up',
                    descendingIcon: 'glyphicon glyphicon-chevron-down',
                    handleIcon: 'glyphicon glyphicon-menu-hamburger',
                    detailRowClass: 'vuetable-detail-row',
                },
                moreParams: {}
            }
        },
        mounted() {
            this.$events.$on('filter-set', eventData => this.onFilterSet(eventData));
            this.$events.$on('filter-reset', e => this.onFilterReset());
        },
        methods: {
            onPaginationData(paginationData) {
                this.$refs.pagination.setPaginationData(paginationData)
                this.$refs.paginationInfo.setPaginationData(paginationData)
            },
            created() {
                let self = this;
                Event.$on('reloadVuetable', function(data) {
                    self.onReloadVuetable();
                });

            },
            onChangePage(page) {
                this.$refs.vuetable.changePage(page)
            },
            formatDate(value, fmt = 'D/MM/YYYY HH:mm') {
                return (value == null) ?
                    '' :
                    moment(value, 'YYYY/MM/DD HH:mm').format(fmt)
            },
            formatNumber(value) {
                return accounting.formatNumber(value, 2, '.', ',')
            },
            onFilterSet(data_filter) {
                this.loadingData = true;
                this.moreParams = {
                    'num_fiscal': data_filter.num_fiscal,
                    'num_controle': data_filter.num_controle,
                    'dt_inicio': data_filter.dt_inicio,
                    'dt_fim': data_filter.dt_fim,
                    'tom_nome': data_filter.tom_nome,
                    'tom_ie': data_filter.tom_ie,
                    'tom_cnpj': data_filter.tom_cnpj,
                    'chave_cte': data_filter.chave_cte,
                    'num_fiscal_cte': data_filter.num_fiscal_cte,
                    'status': data_filter.status.value
                }
                Vue.nextTick(() => this.$refs.vuetable.refresh())
            },
            onFilterReset() {
                this.loadingData = true;
                this.moreParams = {}
                Vue.nextTick(() => this.$refs.vuetable.refresh())
            },
            onFilterShowHide() {
                if (this.vuetableFilterRow) {
                    this.$store.commit('setVuetableFilterRow', false);
                } else {
                    this.$store.commit('setVuetableFilterRow', true);
                }
            },
            onCreate(data) {
                this.modal_titulo = "Gerar Fatura";
                this.modal_botao = "Gerar Fatura"; // OK
                this.modal_acao = "i";
                this.form.fatura_id = [];
                this.$refs.vuetable.selectedTo.forEach((obj) => {
                    this.form.fatura_id.push({
                        id: obj
                    })
                });
                this.form.post('/api/fatura/print').then(response => {
                        new ReturnApi(response, this);
                        Vue.nextTick(() => this.$refs.vuetable.reload());
                    })
                    .catch(errors => {
                        new ReturnApi(errors, this)
                    });
            },
            onPrintFatura(data, tp_print) {
                this.loading = true;
                this.isDisabled = true;
                this.form.fatura_id = [];
                if (tp_print == 2 || tp_print == 3) {
                    this.$refs.vuetable.selectedTo.forEach((obj) => {
                        this.form.fatura_id.push({
                            id: obj
                        })
                    });
                } else if (tp_print == 1) {
                    this.form.fatura_id.push({
                        id: data.fatura_id
                    })
                }
                this.form.tp_print = tp_print;
                this.form.post('/api/fatura/print').then(response => {
                        new ReturnApi(response, this)
                    })
                    .catch(errors => {
                        new ReturnApi(errors, this)
                    });
            },
            onLoaded: function() {
                this.dataExport = this.$refs.vuetable.tableData;
                this.loadingData = false;
                this.$store.commit('setVuetableFilterButton', false);
            },
            onReloadVuetable() {
                this.$refs.vuetable.reload();
            },
            onDetail(data, field, event) {
                this.$refs.vuetable.toggleDetailRow(data.fatura_id);
            },
            getPermission(checkPermission) {
                return this.getPermissionFw(checkPermission);
            },
            onEvento(data, tp_evento, status) {

                let form = this.form;

                let confirmFn = function(vm) {
                    form.fatura_id = data.fatura_id;
                    form.tp_evento = tp_evento;
                    form.status = status;

                    form.post('/api/fatura/evento').then(response => {
                            new ReturnApi(response, vm)
                            vm.$refs.vuetable.reload();
                        })
                        .catch(errors => {
                            new ReturnApi(errors, vm)
                        });
                }

                if (tp_evento == 1) {
                    var vv_descr_evento = "Cancelar";
                    var vv_descr_num = data.num_controle;
                }

                let obj = {
                    title: 'Você deseja ' + vv_descr_evento + ' a fatura ' + vv_descr_num + ' ?',
                    message: 'Esta ação é irreversível',
                    customConfirmBtnText: 'Sim',
                    customCloseBtnText: 'Não',
                    type: 'info',
                    useConfirmBtn: true,
                    onConfirm: confirmFn(this)
                }

                this.$Simplert.open(obj);

                /*
                let dados = data;
                let form = this.form;


                let swal = this.$swal;
                let ref = this.$refs;
                this.$swal({
                      title: 'Você deseja encerrar o MDFE ?',
                      text: "Esta ação é irreversível",
                      type: 'question',
                      showCancelButton: true,
                      confirmButtonText: 'Sim, encerrar!',
                      cancelButtonText: 'Não',
                    }).then(function () {
                        $(this).loading = true;
                        $(this).isDisabled = true;

                    }, function (dismiss) {
                            // Cancel
                    });
                    */
            },
        },
        computed: {
            vuetableFilterRow: {
                get() {
                    return this.$store.getters.vuetable.filterRow;
                },
            },
            isLoaded: {
                get() {
                    return this.$store.getters.isloaded;
                }
            },
            fieldDynamic: {
                get() {
                    if (this.$store.getters.bcliente_active.cd_bcliente == '85' || this.$store.getters.bcliente_active.cd_bcliente == '1512') {
                        return this.fieldsLogin;
                    } else {
                        return this.fields;
                    }
                }
            },
        }
    }

</script>
